import { IControl, Map } from 'maplibre-gl';

// ブラウザUIを残して地図拡大を行うための MapLibre control
export class CustomFullscreenControl implements IControl {
  private map: Map | undefined;
  private container: HTMLDivElement | undefined;
  private button: HTMLButtonElement | undefined;
  private icon: HTMLSpanElement | undefined;
  private enabled = false;

  constructor(private readonly onToggle: (enabled: boolean) => void) {}

  /**
   * 拡大ボタン押下時処理（通常時表示時）
   * @param map: MapLibreの地図
   */
  onAdd(map: Map): HTMLElement {
    this.map = map;

    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl maplibregl-ctrl-group';

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'maplibregl-ctrl-icon matp-fullscreen-btn';

    // Angular Material icon
    this.icon = document.createElement('span');
    this.icon.className = 'material-icons matp-fullscreen-icon';
    this.button.appendChild(this.icon);

    this.button.addEventListener('click', () => {
      this.enabled = !this.enabled;
      this.updateButtonState();
      this.onToggle(this.enabled);
    });

    this.updateButtonState();
    this.container.appendChild(this.button);
    return this.container;
  }

  /**
   * 拡大ボタン押下時処理（拡大表示時から閉じる際の処理）
   */
  onRemove(): void {
    if (this.container?.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.map = undefined;
  }

  /**
   * 拡大ボタンのcssクラスを通常時・拡大時に応じて変更
   */
  private updateButtonState(): void {
    if (!this.button || !this.icon) {
      return;
    }
    this.button.classList.remove('maplibregl-ctrl-fullscreen');
    this.button.classList.remove('maplibregl-ctrl-shrink');
    if (this.enabled) {
      this.button.classList.add('maplibregl-ctrl-shrink');
      this.button.title = 'Exit fullscreen';
      this.button.setAttribute('aria-label', 'Exit fullscreen');
    } else {
      this.button.classList.add('maplibregl-ctrl-fullscreen');
      this.button.title = 'Enter fullscreen';
      this.button.setAttribute('aria-label', 'Enter fullscreen');
    }
    this.icon.textContent = 'fullscreen';
  }
}
